const EventHelper = {
  subscribeEvent: (eventName: string, listener: any) => {
    document.addEventListener(eventName, listener);
  },

  unsubscribeEvent: (eventName: string, listener: any) => {
    document.removeEventListener(eventName, listener);
  },

  publishEvent: (eventName: string, data?: any) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  },

  getDynamicEventName: (eventName: string, toAppend: string) => {
    return `${eventName}_${toAppend}`;
  },
};

export default EventHelper;
